import { render, staticRenderFns } from "./custTransferDetails.vue?vue&type=template&id=1049bec9&scoped=true&"
import script from "./custTransferDetails.vue?vue&type=script&lang=js&"
export * from "./custTransferDetails.vue?vue&type=script&lang=js&"
import style0 from "./custTransferDetails.vue?vue&type=style&index=0&id=1049bec9&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1049bec9",
  null
  
)

export default component.exports